var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-datepicker-filter-fields"},[_c('Input',{attrs:{"left-icon":"Calendar","readonly":"","value":_vm.startDateFormatted}}),_c('div',{staticClass:"t-datepicker-filter-icon"},[_c('Icon',{attrs:{"name":"ArrowRight","size":"18"}})],1),_c('Input',{attrs:{"left-icon":"Calendar","readonly":"","value":_vm.endDateFormatted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }